import { useEffect, useState } from 'react'
import HomeNavbar from '../HomeNavbar'
import { JobList } from './components/JobList'
import { FilterBar } from './components/FilterBar'
import { ApiService } from '../../../api/services.gen'
import { useAlert } from '../../../constants/AlertProvider'

export default function Jobs() {
    const [activeFilter, setActiveFilter] = useState('all')
    const [sortBy, setSortBy] = useState('match')
    const [count, setCount] = useState()
    const showAlert = useAlert()

    useEffect(() => {
        try {
            ApiService.apiJobprofileList().then(
                response => {
                    setCount(response.count || 0)
                }
            )
        } catch (error) {
            showAlert("Error Occurred", "error")
            console.error("Error Occurred", error)
        }
    }, [])
    return (
        <>
            <HomeNavbar />
            <div className="mt-14 flex flex-col min-h-screen bg-gray-50 dark:bg-gray-900 p-6">
                <div className="flex flex-1">
                    <main className="flex-1 px-4 py-6 md:px-8">
                        <h1 className="text-3xl font-semibold text-gray-800 dark:text-gray-100 mb-2">
                            Your Job Matches
                        </h1>
                        <p className="text-gray-600 dark:text-gray-400 mb-6">
                            We found {count} jobs that match your profile
                        </p>
                        <FilterBar
                            activeFilter={activeFilter}
                            setActiveFilter={setActiveFilter}
                            sortBy={sortBy}
                            setSortBy={setSortBy}
                        />
                        <JobList activeFilter={activeFilter} sortBy={sortBy} />
                    </main>
                </div>
            </div>
        </>
    )
}
